/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';

import type { DisambiguatedOrganizationExternalIdentifier } from './DisambiguatedOrganizationExternalIdentifier';
import {
    DisambiguatedOrganizationExternalIdentifierFromJSON,
    DisambiguatedOrganizationExternalIdentifierFromJSONTyped,
    DisambiguatedOrganizationExternalIdentifierToJSON,
    DisambiguatedOrganizationExternalIdentifierToJSONTyped,
} from './DisambiguatedOrganizationExternalIdentifier';

/**
 * 
 * @export
 * @interface DisambiguatedOrganization
 */
export interface DisambiguatedOrganization  {
    /**
     * 
     * @type {string}
     * @memberof DisambiguatedOrganization
     */
    disambiguatedOrganizationIdentifier: string;
    /**
     * 
     * @type {string}
     * @memberof DisambiguatedOrganization
     */
    disambiguationSource: string;
    /**
     * 
     * @type {number}
     * @memberof DisambiguatedOrganization
     */
    id?: number;
    /**
     * 
     * @type {Array<DisambiguatedOrganizationExternalIdentifier>}
     * @memberof DisambiguatedOrganization
     */
    externalIdentifiers?: Array<DisambiguatedOrganizationExternalIdentifier>;
}

/**
 * Check if a given object implements the DisambiguatedOrganization interface.
 */
export function instanceOfDisambiguatedOrganization(value: object): value is DisambiguatedOrganization {
    if (!('disambiguatedOrganizationIdentifier' in value) || value['disambiguatedOrganizationIdentifier'] === undefined) return false;
    if (!('disambiguationSource' in value) || value['disambiguationSource'] === undefined) return false;
    return true;
}

export function DisambiguatedOrganizationFromJSON(json: any): DisambiguatedOrganization {
    return DisambiguatedOrganizationFromJSONTyped(json, false);
}

export function DisambiguatedOrganizationFromJSONTyped(json: any, ignoreDiscriminator: boolean): DisambiguatedOrganization {
    if (json == null) {
        return json;
    }
    return {
        
                  'disambiguatedOrganizationIdentifier': json['disambiguatedOrganizationIdentifier'],
                  'disambiguationSource': json['disambiguationSource'],
                  'id': json['id'] == null ? undefined : json['id'],
              'externalIdentifiers': json['externalIdentifiers'] == null ? undefined : ((json['externalIdentifiers'] as Array<any>).map(DisambiguatedOrganizationExternalIdentifierFromJSON)),
    };
}

export function DisambiguatedOrganizationToJSON(json: any): DisambiguatedOrganization {
    return DisambiguatedOrganizationToJSONTyped(json, false);
}

export function DisambiguatedOrganizationToJSONTyped(value?: DisambiguatedOrganization | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }
    return {
        
        'disambiguatedOrganizationIdentifier': value['disambiguatedOrganizationIdentifier'],
        'disambiguationSource': value['disambiguationSource'],
        'id': value['id'],
        'externalIdentifiers': value['externalIdentifiers'] == null? value['externalIdentifiers']: (value['externalIdentifiers'] as Array<any>).map(DisambiguatedOrganizationExternalIdentifierToJSON),
    };
}


